<template>
  <div>
    <div v-if="loading" class="loader">
      <!-- <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner> -->
      <div class="col-12" style="`overflow-x: hidden; `">
        <div class="row">
          <div class="col-4">
            <idx-skeleton height="208" radius="6"></idx-skeleton>
          </div>
          <div class="col-4">
            <idx-skeleton height="208" radius="6"></idx-skeleton>
          </div>
          <div class="col-4">
            <idx-skeleton height="208" radius="6"></idx-skeleton>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="board-header">
      <template>
        <div>
          <div class="col-12" style="`overflow-x: hidden; `">
            <div class="row pt-4">
              <div
                class="col-4 p-2"
                :style="`text-align: center; min-height: ${
                  dataGraph.layout.h * 35
                }px;`"
              >
                <div class="card-item">
                  <div class="card-body">
                    <header>
                      <span class="title-card">
                        {{ this.$t('reports.summaryBoard.invitesLabel') }}
                      </span>
                    </header>
                    <div class="align-content">
                      <i class="icon fas fa-envelope-open"></i>
                      <span class="description">{{ amountInvites }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-4 p-2"
                :style="`text-align: center; min-height: ${
                  dataGraph.layout.h * 35
                }px;`"
              >
                <div class="card-item">
                  <div class="card-body">
                    <header>
                      <span class="title-card">
                        {{ this.$t('reports.summaryBoard.answersLabel') }}
                      </span>
                    </header>
                    <div class="align-content">
                      <i class="icon fas fa-comment-dots"></i>
                      <span class="description">{{ amountAnswers }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-4 p-2"
                :style="`text-align: center; min-height: ${
                  dataGraph.layout.h * 35
                }px;`"
              >
                <div class="card-item">
                  <div class="card-body">
                    <header>
                      <span class="title-card"> Tx. respostas </span>
                    </header>
                    <div class="align-content">
                      <i class="icon fas fa-clock-o"></i>
                      <span
                        class="description"
                        v-if="!isFinite((amountAnswers / amountInvites) * 100)"
                      >
                        -
                      </span>
                      <span class="description" v-else>
                        {{
                          ((amountAnswers / amountInvites) * 100).toFixed(0)
                        }}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapState } from 'vuex';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import dashboardBar from '@/components/molecules/dashboard-bar';
import npsBar from '@/components/molecules/nps-bar';
import animatedNumber from 'animated-number-vue';
import loader from '@/components/atoms/loader';
import detractorReport from '@/components/molecules/highcharts/detractor-report';
import monthlyDetractorsReport from '@/components/molecules/highcharts/monthly-detractors-report';
import rankings from '@/components/molecules/highcharts/reports/rankings';
import basicColumn from '@/components/molecules/highcharts/reports/basicColumn';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  name: 'SummaryBoard',
  components: {
    npsBar,
    dashboardBar,
    animatedNumber,
    loader,
    detractorReport,
    monthlyDetractorsReport,
    rankings,
    basicColumn,
    idxSkeleton,
  },

  props: ['dataGraph'],

  data: () => ({
    loading: false,
    userAuth: null,
    answersRequest: false,
    clientsRequest: false,
    invitesRequest: false,
    catPromoters: [],
    catDetractors: [],
    details: {},
    branchRanking: 0,
    actionCategories: [],
    amountAnswers: 0,
    amountInvites: 0,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
  },

  watch: {
    'dataGraph.layout.w': function watchWeight(weight) {
      if (weight <= 6) {
        const titles = document.querySelectorAll('.title-card');
        const descriptions = document.querySelectorAll('.description');

        titles.forEach((element) => {
          element.style.fontSize = '18px';
        });

        descriptions.forEach((element) => {
          element.style.fontSize = '15px';
        });
      }
    },
  },

  methods: {
    async getDashboardData() {
      this.loading = true;
      this.answersRequest = true;
      this.clientsRequest = true;
      this.invitesRequest = true;
      this.details = {
        total: 0,
        email: {
          valid: 0,
          percentil: 0,
        },
        sms: {
          valid: 0,
          percentil: 0,
        },
      };

      const responseAnswer = await api.get(`/reports/count-documents-panel`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
          token: this.userAuth.token,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          metric: this.dataGraph.metric,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          period: this.dataGraph.period,
          _id: this.dataGraph._id ? this.dataGraph._id : null,
        },
      });

      this.answersRequest = false;

      this.amountAnswers = responseAnswer.data.answers;

      const responseInvites = await api.get(`/reports/count-invites-panel`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          companyId: this.userAuth.companyId,
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
          token: this.userAuth.token,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          metric: this.dataGraph.metric,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          period: this.dataGraph.period,
          _id: this.dataGraph._id ? this.dataGraph._id : null,
        },
      });

      this.amountInvites = responseInvites.data.invites;

      this.invitesRequest = false;

      this.loading = false;
    },

    formatToPrice(value) {
      return value.toFixed(0);
    },

    getCategoryName(id) {
      for (let i = 0; i < this.actionCategories.length; i += 1) {
        if (id === this.actionCategories[i]._id) {
          return this.actionCategories[i].name;
        }
      }
      return '';
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.loading = true;
    await Promise.all([this.getDashboardData()]);

    if (this.dataGraph.layout.w <= 6) {
      const titles = document.querySelectorAll('.title-card');
      const descriptions = document.querySelectorAll('.description');

      titles.forEach((element) => {
        element.style.fontSize = '18px';
      });

      descriptions.forEach((element) => {
        element.style.fontSize = '15px';
      });
    }

    this.loading = false;
  },

  beforeDestroy() {
    EventBus.$off('switch-chart');
    EventBus.$off('data-source');
    EventBus.$off('accumulated-report');
  },
};
</script>

<style lang="scss">
#number-nps {
  font-size: 50px !important;
}
</style>
<style lang="scss" scoped>
.icon {
  font-size: 27px;
  color: #4de594;
}

.align-content {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
}

.title-card {
  font-weight: 400;
  font-size: 30px;
}

.card-body {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 30px;
  padding-left: 12px;
}

.card-item {
  height: 100%;
  width: 100%;
  background: #fff;
  box-shadow: 0px 2px 6px rgba(41, 70, 97, 0.2);
  border-radius: 4px;
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/summary-board/panels/conversion.vue